import React, { useMemo } from 'react'
import AdWrapper from './AdWrapper'
import DummyAd from './DummyAd'
import { BaseAdProps } from './types'

type GenericAdProps = BaseAdProps & {
  src?: string
}

const GenericAd: React.FC<GenericAdProps> = ({ src, environment, showAds }) => {
  const showPlaceholder = useMemo(() => environment === 'development', [environment])

  const getAdContent = () => {
    if (!showAds || showPlaceholder) {
      return <DummyAd />
    }

    return (
      <iframe
        src={src || undefined}
        frameBorder="0"
        sandbox="allow-forms allow-pointer-lock allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts allow-top-navigation-by-user-activation"
        className="ad"
      />
    )
  }

  return (
    <AdWrapper environment={environment} showAds={showAds}>
      {getAdContent()}
    </AdWrapper>
  )
}

export default GenericAd
